import {useEffect} from 'react';
import {z} from 'zod';
import {Button} from '#/app/components/Button.jsx';
import * as gtag from '#/app/helpers/gtag.client.js';
import {useAdvancedFetcher} from '#/app/helpers/useAdvancedFetcher.jsx';

export const subscribeInputSchema = z.object({
  email: z.coerce.string().email('Please enter a valid email address'),
});

export const SubscribeForm = () => {
  const {handleChange, handleSubmit, isFormDirty, isSubmitting, ...fetcher} = useAdvancedFetcher({
    key: 'newsletter',
    schema: subscribeInputSchema,
  });
  // @ts-expect-error
  const status = isFormDirty ? undefined : fetcher.data?.status;
  const errors = fetcher.data?.errors;

  useEffect(() => {
    gtag.event({action: 'form_error', errors: JSON.stringify(errors), form_id: 'letstalk'});
  }, [errors]);

  return (
    <fetcher.Form
      action="/blog"
      encType="multipart/form-data"
      id="newsletter"
      method="post"
    >
      <input
        name="actionType"
        type="hidden"
        value="subscribe"
      />
      <div className="space-y-4">
        <div className="mx-auto flex flex-col items-center justify-center space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0">
          <div className="w-full sm:max-w-64">
            <input
              className="block h-14 w-full min-w-0 rounded-xl border-2 border-gray-300 px-3.5 py-3 placeholder:text-gray-300 focus:border-sky-500 focus:ring-sky-500 sm:text-lg"
              id="email"
              name="email"
              onChange={handleChange}
              placeholder="Enter your email address"
              type="text"
            />
          </div>
          <Button
            className="h-14"
            color="pink"
            disabled={isSubmitting}
            onClick={handleSubmit}
            type="submit"
          >
            ♥ Subscribe
          </Button>
        </div>
        <div className="mx-auto text-center text-lg">
          {status === 'ok' && <div className="text-green-500">Thank you for subscribing!</div>}
          {errors?.fieldErrors?.email && <div className="text-red-500">{errors?.fieldErrors?.email}</div>}
          {!status && !errors?.fieldErrors?.email && (
            <p className="text-base text-gray-500">Never miss the latest last mile trends again!</p>
          )}
        </div>
      </div>
    </fetcher.Form>
  );
};
